import { ComponentProps, useRef } from "react";
import { useMatch, useSearchParams } from "react-router-dom";
import { MFE, Page, getMFEConfig } from "@sunrun/sales-experience-shared";
import { useIframeMessages, useSynchronizeUrl } from "./common";
import type { IFrame } from "components/atoms/IFrame";

const useChatAdapter = (page: Page): ComponentProps<typeof IFrame> => {
  const ref = useRef<HTMLIFrameElement | null>(null);
  const [searchParams] = useSearchParams();
  const config = getMFEConfig(page as MFE, page as Page);
  const basePath = config.iFrameUrl;
  const match = useMatch(`/${config.containerPath}/*`);
  const src = `${basePath}/${match?.params["*"] ?? ""}?${searchParams}`;
  const { staticSrc } = useSynchronizeUrl(ref, src, basePath);
  useIframeMessages(ref, "Chat", config.containerPath);
  return {
    ref,
    basePath: staticSrc,
    src: src,
    title: config.title,
  };
};

export { useChatAdapter };
